import { buryPoint } from '@/apis/common/buryPoint'
import { addFeedback, getFeedback } from '@/apis/common/feedback'
import { ADSORPTION_RANGE } from '@/data/constant'
import { webId } from '@/util/configure'
import { expandPath } from '@/util/dealPlankDataFuncs'
import { BooleanOperations, Polygon, point } from '@/util/flattenJS/index.cjs'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import {
  diffList as diffListDefault,
  genUniId,
  getUrlParams,
} from '@yige/utils'
import { Modal } from 'ant-design-vue'
import ElementUI from 'element-ui'
import { isString } from 'lodash'
import { nanoid } from 'nanoid'

import store from '../store'
import { getSawKnife, isSawPaiban } from './LayoutFuncs'
import { dealRecord } from './buryPointDeal'
import ClipperLib from './clipper_unminified'
import { translate } from './commonFun'
import { getLShapeGapDir, getPlateKnifeDiameter } from './dealPaibanData'
import {
  dealPathToBasePoint,
  flipPath,
  getCrashPlankByActivePlank,
} from './plankCommonFuncs'

export { arrMapObj, genUniId, getUrlParams } from '@yige/utils'

// import { getUrlVars } from './commonFun'
// blob转为base64
export function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64String = (reader?.result + '').split(',')[1]
      resolve(base64String)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

// import { Message } from 'element-ui'
// 对象数组排序
export function compare(propertyName, type, propertyName2) {
  return function (object1, object2) {
    var value1 = Number(object1[propertyName])
    var value2 = Number(object2[propertyName])
    if (type == 'up') {
      if (value1 == value2 && propertyName2) {
        const value3 = Number(object1[propertyName2])
        const value4 = Number(object2[propertyName2])
        return value4 - value3
      }
      return value1 - value2
    } else if (type == 'down') {
      if (value1 == value2 && propertyName2) {
        const value3 = Number(object1[propertyName2])
        const value4 = Number(object2[propertyName2])
        return value3 - value4
      }
      return value2 - value1
    }
  }
}

// 保留有效数字
export function toDecimal(num, decimal) {
  if (typeof num == 'string') {
    num = Number(num)
  }
  num = num.toFixed(decimal)
  num = Number(num)
  return Number(num)
}
/** @description 保留有效数字(不进行四舍五入) */
export function truncateDecimal(num, decimal) {
  const factor = Math.pow(10, decimal)
  return Math.floor(Number(num) * factor) / factor
}

// 打印当前的内容
export function currentLog(...content) {
  for (let i = 0; i < content.length; ++i) {
    if (typeof content[i] != 'undefined') {
      content[i] = JSON.parse(JSON.stringify(content[i]))
    }
  }
}

// 判断两个值的大小
export function compareTowNum(num1, num2, type) {
  var a = Number(num1)
  var b = Number(num2)
  if (type === '<=') {
    if (a < b || Math.abs(a - b) < 0.0001) return true
  }
  if (type === '>=') {
    if (a > b || Math.abs(a - b) < 0.0001) return true
  }
  if (type === '=') {
    if (Math.abs(a - b) < 0.0001) return true
  }
  if (type === '<') {
    if (a < b && Math.abs(a - b) > 0.0001) return true
  }
  if (type === '>') {
    if (a > b && Math.abs(a - b) > 0.0001) return true
  }
  return false
}

/** 处理Qt操作完成后的回调 */
export function handleQtCB(instance, cb, ...args) {
  if (typeof window.webToQt !== 'undefined') {
    window.signalFromQt.connect((res) => {
      if (res) {
        setTimeout(() => {
          cb.call(instance, ...args)
        })
      }
    })
  }
}

/**
 *
 * @param { string | number } val 值
 * @param { object } verifyObj 验证对象
 * @param { string[] } keys 验证的key
 * @param { string } rule 验证规则  2-3 俩位整数三位小数 4-2 四位整数两位小数
 * @param { boolean } isMinus 是否负数
 * @param {number} min 最小值/默认值
 * @param {boolean} isEmpty 是否允许为空
 * @param {boolean} isThickFlag 是否是原片管理的厚度选项
 */
export function verifyInputNumber(
  val,
  verifyObj,
  keys,
  rule,
  isMinus = false,
  min = 0,
  isEmpty = false,
  max = 0,
  isThickFlag = false
) {
  val += ''
  val = !isMinus ? val.replace(/[^\d\\.]/g, '') : val.replace(/[^\d\\.-]/g, '') // 去掉除数字及.的其它字符
  let finalObj = verifyObj[keys[0]]
  if (keys.length == 1) {
    finalObj = verifyObj
  }
  let lastKey = keys.slice(-1)[0]
  // 删除最后一个key，获取到最后一个key所在的对象
  keys.length = keys.length - 1
  keys.forEach((key, idx) => {
    if (!idx) return
    finalObj = finalObj[key]
  })
  // 增加判断条件，防止在输入为空值时，赋值为0 2025-2-19 原片管理材质厚度变成必填其中一项，这个规则被弃用
  if (
    (!val || (!isMinus && val == '0-')) &&
    !isEmpty &&
    isThickFlag === false
  ) {
    finalObj[lastKey] = 0
    return 0
  }
  const ruleArr = rule.split('-')
  let res
  if (ruleArr.length > 1) {
    // 是否负数对应不同的正则
    const s = isMinus
      ? `(^\\-?)\\D*(\\d{0,${ruleArr[0]}})\\d*(\\.?)(\\d{0,${ruleArr[1]}})\\d*`
      : `\\D*(\\d{0,${ruleArr[0]}})\\d*(\\.?)(\\d{0,${ruleArr[1]}})\\d*`
    const d = isMinus ? '$1$2$3$4' : '$1$2$3'
    const reg = RegExp(s)
    res = val
      .replace(/\.+?/, '(')
      .replace(/\./g, '')
      .replace(/\(/, '.')
      .replace(reg, d)
      .replace(/[^\d\.\-]/, '')
      .replace(/\-+?/, '^')
      .replace(/\-/, '')
      .replace(/\^/, '-')
    // 最后一位是否是小数点,小数点直接返回不是则返回数字
    let strArr = res.split('.')
    if (!isMinus) {
      strArr[0] = Number(strArr[0])
    }
    res = res ? strArr.join('.') : min
  } else {
    // 整数输入限制
    res = val.replace(/[^\d]/g, '').substring(0, ruleArr[0])
    res = parseInt(res)
  }
  if (max && Number(res) > max) res = max
  // 原片管理材质厚度变成必填其中一项，可以为空而不用前强制为0 所以下面这个规则被弃用
  if (isThickFlag && res === 0) {
    res = ''
  }
  finalObj[lastKey] = res
  return res
}

export function checkPlankDataIsCorrect(plank) {
  if (!plank) return
  // 检查大板和小板的stockNum是否一致，不一致将大板stockNum赋值给小板
  const plankStockNum = plank.stockNum
  const plankStockKey = plank.stockKey
  plank.parts.forEach((part) => {
    part.stockNum = plankStockNum
    part.stockKey = plankStockKey
  })
  return plank
}

// 柜门key对应的云排版字段
const _mapData = {
  成品尺寸: 'oRect',
  开料尺寸: 'rect',
  板材颜色: 'texture',
  材质: 'matCode',
}
export function mapGuimenToYPB(part, guimenKey, mapData) {
  mapData = mapData ? mapData : _mapData
  guimenKey.forEach((item) => {
    const { value, label } = item
    const partKey = mapData[label]
    if (partKey) {
      if (partKey == 'oRect' || partKey == 'rect') {
        part[value] = `${part[partKey].height}*${part[partKey].width}*1`
      } else {
        part[value] = part[partKey]
      }
    }
  })
  return part
}

/**
 * 比较两个列表，找出其中的新增项、删除项、剩余项（标记已编辑）
 * @param {*} newArr 新的数据
 * @param {*} oriArr
 * @param {*} keys 比较编辑
 * @param {*} idKey 唯一id
 */
export function diffList(newArr, oriArr, keys, idKey = webId) {
  return diffListDefault(newArr, oriArr, keys, idKey)
}

export function Message(msg) {
  if (typeof msg == 'string') {
    ElementUI.Message({
      duration: 1500,
      offset: 60,
      message: msg.includes('</span>')
        ? msg
        : `<span id="message_tip_text">${msg}</span>`,
      dangerouslyUseHTMLString: true,
    })
  } else {
    ElementUI.Message({
      duration: 1500,
      offset: 60,
      ...msg,
      message: msg.message.includes('</span>')
        ? msg.message
        : `<span id="message_tip_text">${msg.message}</span>`,
      dangerouslyUseHTMLString: true,
    })
  }
}

/**
 * 生成操作的table
 * @param {*} addArr // 新增加的数组
 * @param {*} editArr // 编辑的数组
 * @param {*} deleteArr // 删除的数组
 * @param {*} realShowArr // 最终进行显示的数组（暂时应该包括leaveArr + addArr）
 * @param {*} type // 类型
 * @returns
 */
export function genOperateTable(addArr, editArr, deleteArr, realShowArr, type) {
  addArr = addArr.filter((item) => {
    return item
  })
  editArr = editArr.filter((item) => {
    return item
  })
  deleteArr = deleteArr.filter((item) => {
    return item
  })
  realShowArr = realShowArr.filter((item) => {
    return item
  })

  let nameTemp = ''
  const valueArr = []
  if (addArr.length && !editArr.length) {
    // 只有添加
    nameTemp = '添加'
  } else if (addArr.length && editArr.length) {
    // 既有添加又有编辑
    nameTemp = '添加/编辑'
  } else if (!addArr.length && editArr.length) {
    nameTemp = '编辑'
  }
  // 只有编辑项加增加项的长度大于0的时候，才表明有编辑的内容
  if (
    [...addArr, ...editArr].filter((child) => {
      return child
    }).length
  ) {
    if (type === 'hole_slot_table') {
      // 当是开料机设置的表格时，将内容进行聚合
      let arrHole = []
      let arrSlot = []
      realShowArr.forEach((item) => {
        if (item.item_type === 'hole') {
          arrHole.push(item)
        } else {
          arrSlot.push(item)
        }
      })
      realShowArr = [...arrHole, ...arrSlot]
    }
    valueArr.push({
      key: nameTemp,
      type: type,
      value: realShowArr,
    })
  }
  if (deleteArr.length) {
    valueArr.push({
      key: '删除',
      type: type,
      value: deleteArr,
    })
  }
  return valueArr
}

// 将对象中的属性顺序统一
const sortObj = (obj) => {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})
}

const diffDetail = (newList, oldList, id, options) => {
  id = id || 'webId'
  const diffList = {
    edit: [],
    add: [],
    delete: [],
  }
  const allExcludeKeys = options.excludeKeys.concat([
    'operate_type',
    'uniqueSign',
    'index',
    '_selected',
    'isOld',
  ])
  // 会默认删除掉operate_type属性
  const defaultOptions = {
    ...options,
    excludeKeys: allExcludeKeys,
  }
  const diffDetailList = {
    edit: [],
  }
  const { excludeKeys, includeKeys } = defaultOptions
  newList.forEach((newItem) => {
    const tempNewItem = JSON.parse(JSON.stringify(newItem))
    const oldItem = oldList.find((item) => item[id] === tempNewItem[id])
    // 没找到这个值
    if (!oldItem) {
      // 说明是新增的
      diffList.add.push({ ...newItem, operate_type: 'add' })
      return
    }
    const tempOldItem = JSON.parse(JSON.stringify(oldItem))
    // includeKeys和excludeKeys只能二选一，excludeKeys优先级更高
    if (excludeKeys?.length) {
      excludeKeys.forEach((key) => {
        delete tempNewItem[key]
        delete tempOldItem[key]
      })
    }
    if (includeKeys?.length && !excludeKeys?.length?.length < 4) {
      Object.keys(tempNewItem).forEach((key) => {
        if (!includeKeys.includes(key)) {
          delete tempNewItem[key]
        }
      })
      Object.keys(tempOldItem).forEach((key) => {
        if (!includeKeys.includes(key)) {
          delete tempOldItem[key]
        }
      })
    }

    // tmeNewItem和tempOldItem由于对象中的属性顺序不一样，所以在转成字符串进行比较时会出问题，因此需要先将两个对象中的相同属性的位置统一
    const sortTempNewItem = sortObj(tempNewItem)
    const sortTempOldItem = sortObj(tempOldItem)
    const isSimple =
      JSON.stringify(sortTempNewItem) === JSON.stringify(sortTempOldItem)
    if (tempOldItem && !isSimple) {
      diffList.edit.push([
        newItem,
        { ...oldItem, isOld: true, operate_type: 'edit' },
      ])
      const values = compareObj(tempNewItem, tempOldItem, {}, defaultOptions)
      if (Object.keys(values).length) diffDetailList.edit.push(values)
    }
    // else {
    //   diffList.add.push({ ...tempNewItem, type: 'add' })
    // }
  })
  oldList.forEach((oldItem) => {
    const newItem = newList.find(
      (item) => item[id] !== undefined && item[id] === oldItem[id]
    )
    if (!newItem) {
      diffList.delete.push({ ...oldItem, operate_type: 'delete' })
    }
  })

  return { diffList, diffDetailList }
}

// 比较两个对象是否相等，并且比较属性也是对象的情况
function compareObj(nweItem, oldItem, values = {}, options = {}) {
  const newValues = { ...values }
  // 合并配置，
  options = Object.assign({}, options)
  const { excludeKeys, tableIdentify, includeKeys } = options
  if (!nweItem || !oldItem) return values
  const tempNewItem = JSON.parse(JSON.stringify(nweItem))
  const tempOldItem = JSON.parse(JSON.stringify(oldItem))
  Object.keys(tempNewItem).forEach((key) => {
    if (tempNewItem[key] !== tempOldItem[key]) {
      if (
        Object.prototype.toString.call(tempNewItem[key]) ===
          '[object Object]' &&
        Object.prototype.toString.call(tempOldItem[key]) === '[object Object]'
      ) {
        compareObj(tempNewItem[key], tempOldItem[key], newValues, options)
      } else if (
        Array.isArray(tempNewItem[key]) &&
        Array.isArray(tempOldItem[key])
      ) {
        tempNewItem[key].forEach((item, index) => {
          compareObj(item, tempOldItem[key][index], newValues, options)
        })
      } else {
        newValues[nweItem[tableIdentify]] =
          newValues[nweItem[tableIdentify]] || []
        newValues[nweItem[tableIdentify]].push({
          key,
          oldValue: tempOldItem[key],
          value: tempNewItem[key],
        })
      }
    }
  })
  const newValue = Object.keys(newValues).map((key) => {
    return {
      key,
      value: values[key],
    }
  })
  return newValue
}
// 为items的每一项添加item
export function addIdForItems(items, idKey = webId, flag = '') {
  // 兼容之前写法，不修改原有的逻辑
  // if (change) return addIdForItemsDefault(items, idKey)
  // 生成不会更改的id
  if (Array.isArray(items)) {
    items.forEach((item) => {
      if (!item[idKey]) {
        item[idKey] = genUniId()
      }
      if (item.items) {
        addIdForItems(item.items, idKey, false)
      }
    })
  }
  return items
}

/**
 * 遍历compareMsg，取出keys里面的key，比较当前数据与原始数据是否发生变化
 * @param {*} current
 * @param {*} ori
 * @param {*} compareMsg  根据compareMsg里面的内容进行设置
 * { // 格式
      title: '工位开始',
      keys: ['autoSendStockCode', 'rollCode'],
    }
 * @param {*} record
 */
export function compareDiffForm(
  current,
  ori,
  compareMsg,
  formTextObj,
  formValueObj = {}
) {
  let record = []
  compareMsg.forEach((item) => {
    let arr = []

    item.keys.forEach((key) => {
      const currentItem =
        typeof current[key] === 'object'
          ? JSON.stringify(current[key])
          : current[key]
      const oriItem =
        typeof ori[key] === 'object' ? JSON.stringify(ori[key]) : ori[key]
      if (currentItem !== oriItem) {
        if (typeof current[key] === 'object' && !Array.isArray(current[key])) {
          Object.keys(current[key]).forEach((k) => {
            if (current[key][k] !== ori[key][k]) {
              // formValueObj[key][k] 为对象时表示值→展示文案映射，为字符串时表示字段中文名，直接展示原值
              const valueMap = formValueObj[key]?.[k]
              const isValueMap =
                valueMap &&
                typeof valueMap === 'object' &&
                !Array.isArray(valueMap)
              const currentV = isValueMap
                ? valueMap[current[key][k]]
                : current[key][k]
              const oldV = isValueMap ? valueMap[ori[key][k]] : ori[key][k]
              // 子项 key：formTextObj 无嵌套时取不到，translate(undefined) 可能返回 ''，?? 不替空串，用 || 兜底到 formValueObj[key][k]（字符串）或 k
              const textKey =
                translate(formTextObj[key]?.[k]) ?? formTextObj[key]?.[k]
              const subKey =
                textKey != null && textKey !== ''
                  ? textKey
                  : typeof formValueObj[key]?.[k] === 'string'
                  ? formValueObj[key][k]
                  : k
              arr.push({
                key: subKey,
                value: currentV,
                oldValue: oldV === undefined ? '' : oldV,
              })
            }
          })
        } else if (Array.isArray(current[key])) {
          arr.push({
            key: translate(formTextObj[key]) ?? formTextObj[key],
            value: currentItem,
            // 表单最后匹配的数据不同时，保存旧的值
            oldValue: oriItem === undefined ? '' : oriItem,
          })
        } else {
          const valueMap = formValueObj[key]
          const isValueMap =
            valueMap && typeof valueMap === 'object' && !Array.isArray(valueMap)
          const currentV = isValueMap ? valueMap[current[key]] : current[key]
          const oldV = isValueMap ? valueMap[ori[key]] : ori[key]

          arr.push({
            key: translate(formTextObj[key]) ?? formTextObj[key],
            value: currentV,
            // 表单最后匹配的数据不同时，保存旧的值
            oldValue: oldV === undefined ? '' : oldV,
          })
        }
      }
    })
    if (arr.length) {
      // 如果 title 为空，直接将 arr 中的内容展开到 record 中
      if (item.title === '') {
        arr.forEach((arrItem) => {
          record.push({
            key: '',
            value: [arrItem],
          })
        })
      } else {
        // 有 title 且 arr 中每项带非空 key：按「title-子项 key」展开为叶子，避免修改记录里 key 为空
        const hasNestedKey = arr.some((a) => a.key != null && a.key !== '')
        if (hasNestedKey) {
          arr.forEach((arrItem) => {
            record.push({
              key: item.title + (arrItem.key ? '-' + arrItem.key : ''),
              value: arrItem.value,
              oldValue: arrItem.oldValue === undefined ? '' : arrItem.oldValue,
            })
          })
        } else {
          record.push({
            key: item.title,
            value: arr,
          })
        }
      }
    }
  })
  return record
}

// 平铺对象，只平铺一层
export function flatObj(temp) {
  let tempFlat = {}
  // 将当前对象铺平
  for (let key in temp) {
    if (isPlainObject(temp[key])) {
      tempFlat = {
        ...tempFlat,
        ...temp[key],
      }
    } else {
      tempFlat[key] = temp[key]
    }
  }
  return tempFlat
}

/**
 * 给record添加操作表格记录
 * @param {*} newList // 新列表
 * @param {*} oriList // 旧列表
 * @param {*} keys // 要比较的keys
 * @param {*} tableType // 表格对应的type
 * @param {*} recordKeyDesc // 操作记录对应的key
 * @param {*} record // 记录
 */
export function addOperateTableToRecord(
  newList,
  oriList,
  keys = [],
  tableType,
  recordKeyDesc,
  record,
  idKey = '',
  tableIdentify = 'desc',
  excludeKeys = []
) {
  // const { addArr, deleteArr, leaveArr, editArr } = idKey
  //   ? diffList(newList, oriList, keys, idKey)
  //   : diffList(newList, oriList, keys)
  const {
    diffList: { edit, add, delete: deleteArr },
    diffDetailList: { edit: editDetail },
  } = diffDetail(newList, oriList, idKey, {
    tableIdentify,
    excludeKeys,
    includeKeys: keys,
  })
  // 生成最终的操作table
  // const valueArr = genOperateTable(
  //   addArr,
  //   [],
  //   deleteArr,
  //   [...leaveArr, ...addArr],
  //   tableType
  // )
  // if (valueArr.length) {
  //   record.push({
  //     key: recordKeyDesc,
  //     value: valueArr,
  //   })
  // }
  if (editDetail.length) {
    record.push({
      key: recordKeyDesc,
      value: editDetail,
    })
  }
  if (edit.length) {
    record.push({
      key: recordKeyDesc,
      value: [
        {
          key: '编辑',
          type: tableType,
          value: edit.flat(),
        },
      ],
    })
  }
  if (add.length) {
    record.push({
      key: recordKeyDesc,
      value: [
        {
          key: '新增',
          type: tableType,
          value: add.flat(),
        },
      ],
    })
  }
  if (deleteArr.length) {
    record.push({
      key: recordKeyDesc,
      value: [
        {
          key: '删除',
          type: tableType,
          value: deleteArr.flat(),
        },
      ],
    })
  }
}

// 比较操作item
function compareOperateItem(operateItem) {
  const record = []
  operateItem.dataArr.forEach((dataItem) => {
    if (dataItem.type === 'form') {
      // 处理form的情况
      const compareMsg = dataItem.compareMsg
      const formChangeArr = compareDiffForm(
        dataItem.current,
        dataItem.ori,
        compareMsg,
        dataItem.formTextObj,
        dataItem.formValueObj
      )
      if (formChangeArr.length) {
        record.push(...formChangeArr)
      }
    } else if (dataItem.type === 'table') {
      // 处理table情况
      addOperateTableToRecord(
        dataItem.list,
        dataItem.oriList,
        dataItem.keys,
        dataItem.tableType,
        dataItem.key,
        record,
        dataItem.idKey || 'webId', // 兼容大多数默认情况，使用webId
        dataItem.tableIdentify,
        dataItem.excludeKeys || []
      )
    }
  })

  return record
}

/**
 * 产生最终的操作记录
 * @param {*} recordData
 * let recordData = {
      key: "", // 操作记录最外层的名字，比如：雕刻机
      operateArr: [ // 应对多个操作页面时，比如雕刻机的操作页面
        {
          key: "",
          dataArr: [ // 氛围表单和table两种
            ({
              type: "form",
              current, // 当前表单数据
              ori, // 原始表单数据
              compareMsg, // 要比较的内容
              formTextObj, // key对应的意思
              formValueObj, // value对应的意思
            },
            {
              type: "table",
              list, // 当前列表
              oriList, // 原始列表
              keys: [], // 列表要比较的keys
              tableType, // table 的 type
              key, // 表格对应的key
            }),
          ],
        },
      ],
    };
 * @param {*} cb
 */
export function genFinalRecord(recordData, action_type, id, cb) {
  if (typeof id === 'function') {
    cb = id
  }
  let operateRecordArr = []
  const record = [
    {
      key: recordData.key,
      value: operateRecordArr,
    },
  ]
  // 遍历所有的操作页面
  recordData.operateArr.forEach((operateItem) => {
    const compareRecord = compareOperateItem(operateItem)
    if (compareRecord.length) {
      const buryPointArr = []
      compareRecord.forEach((item) => {
        if (item.key == '其他') {
          item.value.forEach((valueItem) => {
            switch (valueItem.key) {
              case '工位1自动上料代码':
                buryPointArr.push({
                  function_module: 'engraving',
                  function_point: 'autoSendStockCode',
                })
                break
              case '工位2自动上料代码':
                buryPointArr.push({
                  function_module: 'engraving',
                  function_point: 'evenAutoSendStockCode',
                })
                break
            }
          })
        }
        if (item.key == '台面设置') {
          item.value.forEach((valueItem) => {
            switch (valueItem.key) {
              case '大工位只加工小工位无法加工的大板':
                buryPointArr.push({
                  function_module: 'engraving',
                  function_point: 'smallStationFirst',
                })
                break
            }
          })
        }
      })
      if (buryPointArr.length) buryPoint(buryPointArr)
      operateRecordArr.push({
        key: operateItem.key,
        value: compareRecord,
      })
    }
  })
  if (operateRecordArr.length) {
    const setting_id = getUrlParams('setting_id')
    let finalId = setting_id
    if (typeof id === 'string' || typeof id === 'number') {
      finalId = id
    }
    const isForbidOss = false
    dealRecord(record)
    if (isForbidOss) {
      if (typeof cb === 'function') {
        cb()
      }
    } else {
      saveDataJsonToOssForRecord(
        record,
        action_type,
        { id: finalId }, // getUrlParams('line')是对应的生产线名字
        cb
      )
    }
  }
}
/**
 * 将genFinalRecord使用promise改写
 */
export function genFinalRecordPromise(recordData, action_type, id) {
  return new Promise((resolve, reject) => {
    try {
      if (typeof id === 'function') {
        cb = id
      }
      let operateRecordArr = []
      const record = [
        {
          key: recordData.key,
          value: operateRecordArr,
        },
      ]
      // 遍历所有的操作页面
      recordData.operateArr.forEach((operateItem) => {
        const compareRecord = compareOperateItem(operateItem)
        if (compareRecord.length) {
          const buryPointArr = []
          compareRecord.forEach((item) => {
            if (item.key == '其他') {
              item.value.forEach((valueItem) => {
                switch (valueItem.key) {
                  case '工位1自动上料代码':
                    buryPointArr.push({
                      function_module: 'engraving',
                      function_point: 'autoSendStockCode',
                    })
                    break
                  case '工位2自动上料代码':
                    buryPointArr.push({
                      function_module: 'engraving',
                      function_point: 'evenAutoSendStockCode',
                    })
                    break
                }
              })
            }
            if (item.key == '台面设置') {
              item.value.forEach((valueItem) => {
                switch (valueItem.key) {
                  case '大工位只加工小工位无法加工的大板':
                    buryPointArr.push({
                      function_module: 'engraving',
                      function_point: 'smallStationFirst',
                    })
                    break
                }
              })
            }
            if (item.key == '切割打孔方式') {
              item.value.forEach((valueItem) => {
                switch (valueItem.key) {
                  case '设置不生效翻面两次打穿孔':
                    buryPointArr.push({
                      function_module: 'engraving',
                      function_point: 'isSpecialThroughTwoSideToCut',
                    })
                    break
                }
              })
            }
          })
          if (buryPointArr.length) buryPoint(buryPointArr)
          operateRecordArr.push({
            key: operateItem.key,
            value: compareRecord,
          })
        }
      })

      if (operateRecordArr.length) {
        const setting_id = getUrlParams('setting_id')
        let finalId = setting_id
        if (typeof id === 'string' || typeof id === 'number') {
          finalId = id
        }
        dealRecord(record)
        resolve({
          record,
          finalId,
          action_type,
        })
      }
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * 第三方设备权限
 * @param { string } path 第三方进入的路径
 * @param { boolean } auth 权限
 */
const verify = {
  '/labeling': 'labeling',
  '/dockFiveSix': 'dock56F',
  '/bluenPtp': 'ptp',
}
export function thirdPermission(path) {
  let { edition_id, third_permissions } = store.state.userInfo
  const key = verify[path]
  let flag = true
  if (!key) return flag
  if (![5, 6, 14, 19, 20].includes(edition_id)) {
    flag = !!third_permissions[key]
  }
  if (!flag)
    Message({
      type: 'info',
      message: '暂无此权限, 请升级账号版本!',
      duration: 1500,
      offset: 70,
    })
  return flag
}

/**
 * 计算板件尺寸
 * @param { array } plank
 */
export function calcPlankSize(plank, isAbnormity = false) {
  const { xyReverse } = store.state.ncSetting

  if (isAbnormity) {
    const obj = plank.surplusInfo
    const xArr = Object.keys(obj)
      .filter((key) => key[0] === 'x')
      .map((key) => obj[key])
      .concat([0])
    const yArr = Object.keys(obj)
      .filter((key) => key[0] === 'y')
      .map((key) => obj[key])
      .concat([0])
    const maxX = Math.max(...xArr)
    const minX = Math.min(...xArr)
    const middleX = xArr.find((x) => x !== maxX && x !== minX)
    const maxY = Math.max(...yArr)
    const minY = Math.min(...yArr)
    const middleY = yArr.find((y) => y !== maxY && y !== minY)
    return {
      longW: plank.plankWidth,
      shortW: xyReverse ? middleY : middleX,
      longH: plank.plankHeight,
      shortH: xyReverse ? middleX : middleY,
    }
  } else {
    return { width: plank.plankWidth, height: plank.plankHeight }
  }
}

const modalIcon = {
  warning: 'question-circle',
  error: 'exclamation-circle',
  success: 'check-circle  ',
  info: 'info-circle',
}
export function modalMsg(
  msg,
  type = 'warning',
  title = '提示',
  cb = null,
  other = {},
  from
) {
  if (typeof msg === 'string') {
    msg =
      from === 'getLayoutData' && msg.includes('\n') ? msg.split('\n') : [msg]
  }
  const config = {
    title,
    type,
    icon: modalIcon[type],
    centered: true,
    content: (h) =>
      h('div', null, [
        ...msg.map((str, index) =>
          h(
            'p',
            from === 'getLayoutData' && index % 2 === 0
              ? { style: { color: 'red' } }
              : null,
            str
          )
        ),
      ]),
    okText: '确定',
    cancelButtonProps: { style: { display: 'none' } },
    onOk() {
      cb && cb()
    },
    ...other,
  }
  const modal = Modal.confirm(config)
  return modal
}

/**
 *  板件吸附功能
 * @param {array} activePlank 移动的板件
 * @param {array} parts 该大板内所有的板件
 */
export function calcClosePoint(activePlank, parts) {
  if (!parts.length) return
  const rect = [
    { x: activePlank.startX, y: activePlank.startY },
    {
      x: activePlank.startX + activePlank.rect.width,
      y: activePlank.startY,
    },
    {
      x: activePlank.startX,
      y: activePlank.startY + activePlank.rect.height,
    },
    {
      x: activePlank.startX + activePlank.rect.width,
      y: activePlank.startY + activePlank.rect.height,
    },
  ]
  const otherReact = parts
    .filter(
      (part) =>
        part.plankID !== activePlank.plankID || part.index !== activePlank.index
    )
    .map((part) => {
      return [
        { x: part.startX, y: part.startY },
        {
          x: part.startX + part.rect.width,
          y: part.startY,
        },
        {
          x: part.startX,
          y: part.startY + part.rect.height,
        },
        {
          x: part.startX + part.rect.width,
          y: part.startY + part.rect.height,
        },
      ]
    })
    .flat(2)
  let xArr = []
  let yArr = []
  rect.forEach((e) => {
    xArr.push(Math.min(...otherReact.map((o) => Math.abs(o.x - e.x))))
    yArr.push(Math.min(...otherReact.map((o) => Math.abs(o.y - e.y))))
  })
  const minX = Math.min(...xArr)
  const minY = Math.min(...yArr)
  const xPoints = Array.from(
    new Set(
      rect
        .map((e) => {
          return otherReact.filter((o) => Math.abs(o.x - e.x) == minX)
        })
        .flat(1)
    )
  )
  const yPoints = Array.from(
    new Set(
      rect
        .map((e) => {
          return otherReact.filter((o) => Math.abs(o.y - e.y) == minY)
        })
        .flat(1)
    )
  )
  // flagX  true说明移动板件处于右边 false 在左边
  let flagX = xPoints[0].x - activePlank.startX <= 0
  // flagY  true在下 false在上 （都是相对于startX,startY）
  let flagY = yPoints[0].y - activePlank.startY <= 0

  let x = rect[0].x
  let y = rect[0].y
  if (minX <= 20) {
    x = flagX
      ? xPoints[0].x
      : xPoints[0].x - activePlank.startX == minX //顶部靠近
      ? xPoints[0].x
      : xPoints[0].x - activePlank.rect.width
  }
  if (minY <= 20) {
    y = flagY
      ? yPoints[0].y
      : yPoints[0].y - activePlank.startY == minY //顶部靠近
      ? yPoints[0].y
      : yPoints[0].y - activePlank.rect.height
  }

  return {
    x,
    y,
  }
}
/**
 * 生成一个唯一的plankNum 使用需要在执行完成后清空set
 */
function createUniquePlankNum(part = null, isSurplus = false) {
  if (part && part.plankNum) return part.plankNum
  let finalPlankNum = ''
  do {
    let date = new Date()
    let time = date.getTime()
    let plankNum = ('' + time).slice(-12)
    let strArr = plankNum.split('')

    if (isSurplus) {
      const time = String(store.state.userInfo.time ?? '').split('')
      if (time && time.length) {
        const loginTimeLastTwo = time.slice(-4)
        strArr.splice(
          0,
          4,
          loginTimeLastTwo[0] == 0 ? randomNonZeroNum() : loginTimeLastTwo[0],
          loginTimeLastTwo[1],
          loginTimeLastTwo[2],
          loginTimeLastTwo[3]
        )
      } else {
        strArr.splice(
          0,
          4,
          randomNonZeroNum(),
          randomNonZeroNum(false),
          randomNonZeroNum(false),
          randomNonZeroNum(false)
        )
      }
    }
    let num1 = 0
    let num2 = 0
    for (let i = 0; i < strArr.length; ++i) {
      if (i == 0) {
        if (strArr[i] == '0') {
          strArr[i] = randomNonZeroNum()
        }
      }
      if ((i + 1) % 2) {
        num2 += Number(strArr[i])
      } else {
        num1 += Number(strArr[i])
      }
    }
    /** EAN13的校验码计算公式，请勿改动 */
    const finalNum = 10 - (((num1 * 3 + num2) % 10) % 10)
    strArr.push(finalNum == 10 ? 0 : finalNum)
    finalPlankNum = strArr.join('')
  } while (this.plankNumCollect.has(finalPlankNum))
  this.plankNumCollect.add(finalPlankNum)
  return finalPlankNum
}

// 随机非零数字
export function randomNonZeroNum(isNonZero = true) {
  return isNonZero
    ? Math.floor(Math.random() * 9 + 1)
    : Math.floor(Math.random() * 10)
}

export const uniquePlankNum = {
  plankNumCollect: new Set(),
  createUniquePlankNum,
}
/**
 *
 * @param { Array } arr 当前数组
 * @param {*} curIdx 当前下标
 * @param {*} next 需要取出的下标位数  如 -2 向后两位下标取值 2 向前两位下标取值
 * @returns index 找到的下标 下标对应的值
 */
export function getArrayItem(arr, curIdx, next) {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    throw new Error('arguments[0] is not Array')
  }
  let index
  if (next < 0) {
    index = (arr.length + curIdx - Math.abs(next)) % arr.length
  } else {
    index = (curIdx + next) % arr.length
  }
  return { index, res: arr[index] }
}

/**
 * 获取旋转后的对象
 * @param {Object} box 原始对象 {left, bottom, right, top }
 * @param {number} deg 旋转角度
 * @param {boolean} cw 是否顺时针旋转
 * @returns {Object} 旋转后的对象
 */
export function getRotateObject(box, deg, cw = true) {
  const dirs = ['top', 'right', 'bottom', 'left']
  const values = dirs.map((k) => box[k])
  // 计算旋转步数（每 90 度一步）
  let steps = (deg / 90) % 4
  if (!cw) steps = (4 - steps) % 4
  // 循环右移 steps 次
  const rotated = values.map((_, i) => values[(i - steps + 4) % 4])
  return Object.fromEntries(dirs.map((k, i) => [k, rotated[i]]))
}
/**
 * @description 获取翻面后的对象/分左右的上下
 * @param {Object} box 原始对象 {left, bottom, right, top }
 * @returns {Object} 翻面后的对象
 */
export function getFlipObject(box, flipDirection = 'leftRight') {
  if (!box) return
  if (flipDirection === 'leftRight') {
    return {
      left: box.right,
      right: box.left,
      top: box.top,
      bottom: box.bottom,
    }
  } else {
    return {
      left: box.left,
      right: box.right,
      top: box.bottom,
      bottom: box.top,
    }
  }
}
// // 处理封边一类的信息在板件变化时的处理
// export function dealEdgeInfoChange(edgeInfo, way) {
//   if (!edgeInfo) return
//   let res
//   const [Left, Bottom, Right, Top] = edgeInfo
//     .split(/←|↓|→|↑/)
//     .filter((it) => it)
//   switch (way) {
//     case 'xyReverse':
//       res = '←' + Top + '↓' + Right + '→' + Bottom + '↑' + Left
//       break
//     case 90:
//       res = '←' + Bottom + '↓' + Right + '→' + Top + '↑' + Left
//       break
//     case 180:
//       res = '←' + Right + '↓' + Top + '→' + Left + '↑' + Bottom
//       break
//     case 'fan':
//       res = '←' + Left + '↓' + Top + '→' + Right + '↑' + Bottom
//       break
//   }
//   return res
// }
// // 处理前封边和开门在板件变化的处理
// const openMap = {
//   上开: '下开',
//   下开: '上开',
// }
// const edgeMap = {
//   '↑': '↓',
//   '↓': '↑',
// }
// export function dealFormerEdgeChange(former, way, isOpen = false) {
//   if (!former) return
//   const edge = isOpen ? ['左开', '下开', '右开', '上开'] : ['←', '↓', '→', '↑']
//   const idx = edge.findIndex((it) => it == former)
//   let next
//   let res
//   switch (way) {
//     case 90:
//       next = -1
//       break
//     case 180:
//       next = -2
//       break
//     case 'fan':
//       res = isOpen ? openMap[former] : edgeMap[former]
//       res = res ?? former
//       break
//   }
//   if (!res) {
//     const result = getArrayItem(edge, idx, next)
//     res = result.res
//   }
//   return res
// }
// 延时
export function delay(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

// 生成simplePlankNum
export function generateSimplePlankNum(part) {
  const { simplePlankNum: preSimplePlankNum, plankID, orderNo, roomID } = part
  if (preSimplePlankNum && preSimplePlankNum !== 'None') return
  let simplePlankNum = `000-${plankID}`
  if (orderNo && roomID) {
    const [first] = orderNo.split(/[*\-_/]/).slice(-1)
    const last = roomID.toString().substring(0, 2)
    simplePlankNum = `${first.substring(0, 3)}${last}-${plankID}`
  }
  // 生成正反面条码
  part.simplePlankNum = simplePlankNum
  part.simplePlankNumF = simplePlankNum + 'K'
}

// 生成simplePlankNum
export function generateSimplePlankNumFn(part) {
  const { simplePlankNum: preSimplePlankNum, plankID, orderNo, roomID } = part
  if (preSimplePlankNum && preSimplePlankNum !== 'None') return {}
  let simplePlankNum = `000-${plankID}`
  if (orderNo && roomID) {
    const [first] = orderNo.split(/[*\-_/]/).slice(-1)
    const last = roomID.toString().substring(0, 2)
    simplePlankNum = `${first.substring(0, 3)}${last}-${plankID}`
  }
  return {
    simplePlankNum,
    simplePlankNumF: simplePlankNum + 'K',
  }
}

// 获取原始顺序的宽高
export function getOriginRect(part, field = 'oRect') {
  const { specWidth, specHeight } = part
  if (!specHeight || !specWidth) return part[field]
  const { width, height } = part[field]
  const { width: checkWidth, height: checkHeight } = part.oRect
  return checkWidth - specWidth === checkHeight - specHeight
    ? { width, height }
    : { width: height, height: width }
}

// 是否是相同的板件
export function isSamePart(part1, part2) {
  return part1.partUniqueId === part2.partUniqueId
}
export function generatePlankId(parts) {
  let maxPlankId = Math.max(
    ...parts.map((item) => (+item.plankID ? item.plankID : -999))
  )
  if (maxPlankId == -999) maxPlankId = 0
  return maxPlankId + 1
}

/**
 * 以某个key对数组内数据进行归类
 * @param {array} data 数据源
 * @param {string} key 以此key进行聚类
 * @param {string} itemKey 被聚类的item存储的key
 * @param {Function} cb 每一步聚类的回调 参数：是否存在，当前数据，当前对象，当前key
 * @param {string} returnFormat 返回的数据格式
 * @returns
 */
export function dataClustering(
  data,
  key,
  itemKey,
  cb = null,
  returnFormat = 'Object'
) {
  let hash = {}
  for (const item of data) {
    const targetKey = item[key]
    const targetItemKey = item[itemKey]
    if (hash[targetKey]) {
      const target = hash[targetKey][targetItemKey]
      // 内部单个数据是否存在，存在则直接使用旧数据
      if (!target) {
        hash[targetKey][targetItemKey] = item
        cb && cb('notExists', item)
      } else {
        cb && cb('exists', target)
      }
    } else {
      // 整体不存在
      hash[targetKey] = {
        [targetItemKey]: item,
      }
      cb && cb(null, item)
    }
  }
  switch (returnFormat) {
    case 'Array':
      hash = Object.values(hash).map((it) => Object.values(it))
      break
  }
  return hash
}
export const buryPointApi = async (function_module, function_point) => {
  const buryPointData = {
    function_module,
    function_point,
  }

  await buryPoint(buryPointData)
}
export const addFeedbackApi = async (addFeedbackData) => {
  return await addFeedback(addFeedbackData)
}
export const getFeedbackApi = async (getFeedbackData) => {
  return await getFeedback(getFeedbackData)
}
export const judgeEnv = () => {
  let env
  const envObj = {
    test: 'https://test-api.eggrj.com/bluen',
    master: 'https://server.bluen.cn',
    online: 'https://online-api.eggrj.com/bluen',
  }
  for (const key in envObj) {
    if (process.env.VUE_APP_BASE_URL.includes(envObj[key])) {
      env = key
    }
  }
  return env
}
export const getTryProductionRoomId = () => {
  const env = judgeEnv()
  let roomID
  switch (env) {
    case 'test':
      roomID = 3017767
      break
    case 'online':
      roomID = 14462333
      break
    case 'master':
      roomID = 17264591
      break
    default:
      roomID = 3017767
  }
  return roomID
}
export const canvas2Image = (function () {
  // check if support sth.
  let $support = (function () {
    let canvas = document.createElement('canvas'),
      ctx = canvas.getContext('2d')

    return {
      canvas: !!ctx,
      imageData: !!ctx.getImageData,
      dataURL: !!canvas.toDataURL,
      btoa: !!window.btoa,
    }
  })()

  let downloadMime = 'image/octet-stream'

  function scaleCanvas(canvas, width, height) {
    let w = canvas.width,
      h = canvas.height
    if (width == undefined) {
      width = w
    }
    if (height == undefined) {
      height = h
    }

    let retCanvas = document.createElement('canvas')
    let retCtx = retCanvas.getContext('2d')
    retCanvas.width = width
    retCanvas.height = height
    retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height)
    return retCanvas
  }

  function getDataURL(canvas, type, width, height) {
    canvas = scaleCanvas(canvas, width, height)
    return canvas.toDataURL(type)
  }

  function saveFile(strData) {
    document.location.href = strData
  }

  function genImage(strData) {
    let img = document.createElement('img')
    img.src = strData
    return img
  }
  function fixType(type) {
    type = type.toLowerCase().replace(/jpg/i, 'jpeg')
    let r = type.match(/png|jpeg|bmp|gif/)[0]
    return 'image/' + r
  }
  function encodeData(data) {
    if (!window.btoa) {
      throw 'btoa undefined'
    }
    let str = ''
    if (typeof data == 'string') {
      str = data
    } else {
      for (let i = 0; i < data.length; i++) {
        str += String.fromCharCode(data[i])
      }
    }

    return btoa(str)
  }
  function getImageData(canvas) {
    let w = canvas.width,
      h = canvas.height
    return canvas.getContext('2d').getImageData(0, 0, w, h)
  }
  function makeURI(strData, type) {
    return 'data:' + type + ';base64,' + strData
  }

  /**
   * create bitmap image
   * 按照规则生成图片响应头和响应体
   */
  const genBitmapImage = function (oData) {
    //
    // BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
    // BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
    //

    let biWidth = oData.width
    let biHeight = oData.height
    let biSizeImage = biWidth * biHeight * 3
    let bfSize = biSizeImage + 54 // total header size = 54 bytes

    const BITMAPFILEHEADER = [
      0x42,
      0x4d,
      bfSize & 0xff,
      (bfSize >> 8) & 0xff,
      (bfSize >> 16) & 0xff,
      (bfSize >> 24) & 0xff,
      0,
      0,
      0,
      0,
      54,
      0,
      0,
      0,
    ]

    const BITMAPINFOHEADER = [
      40,
      0,
      0,
      0,
      biWidth & 0xff,
      (biWidth >> 8) & 0xff,
      (biWidth >> 16) & 0xff,
      (biWidth >> 24) & 0xff,
      biHeight & 0xff,
      (biHeight >> 8) & 0xff,
      (biHeight >> 16) & 0xff,
      (biHeight >> 24) & 0xff,
      1,
      0,
      24,
      0,
      0,
      0,
      0,
      0,
      biSizeImage & 0xff,
      (biSizeImage >> 8) & 0xff,
      (biSizeImage >> 16) & 0xff,
      (biSizeImage >> 24) & 0xff,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ]

    let iPadding = (4 - ((biWidth * 3) % 4)) % 4

    let aImgData = oData.data

    let strPixelData = ''
    let biWidth4 = biWidth << 2
    let y = biHeight
    let fromCharCode = String.fromCharCode

    do {
      let iOffsetY = biWidth4 * (y - 1)
      let strPixelRow = ''
      for (let x = 0; x < biWidth; x++) {
        let iOffsetX = x << 2
        strPixelRow +=
          fromCharCode(aImgData[iOffsetY + iOffsetX + 2]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX + 1]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX])
      }

      for (let c = 0; c < iPadding; c++) {
        strPixelRow += String.fromCharCode(0)
      }

      strPixelData += strPixelRow
    } while (--y)

    const strEncoded =
      encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER)) +
      encodeData(strPixelData)

    return strEncoded
  }

  /**
   * saveAsImage
   * @param canvasElement
   * @param {String} image type
   * @param {Number} [optional] png width
   * @param {Number} [optional] png height
   */
  const saveAsImage = function (canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == 'string') {
        canvas = document.getElementById(canvas)
      }
      if (type == undefined) {
        type = 'png'
      }
      type = fixType(type)
      let strData
      if (/bmp/.test(type)) {
        const data = getImageData(scaleCanvas(canvas, width, height))
        strData = genBitmapImage(data)
        saveFile(makeURI(strData, downloadMime))
      } else {
        strData = getDataURL(canvas, type, width, height)
        saveFile(strData.replace(type, downloadMime))
      }
    }
  }

  const convertToImage = function (canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == 'string') {
        canvas = document.getElementById(canvas)
      }
      if (type == undefined) {
        type = 'png'
      }
      type = fixType(type)
      let strData
      if (/bmp/.test(type)) {
        const data = getImageData(scaleCanvas(canvas, width, height))
        strData = genBitmapImage(data)
        return genImage(makeURI(strData, 'image/bmp'))
      } else {
        strData = getDataURL(canvas, type, width, height)
        return genImage(strData)
      }
    }
  }

  return {
    saveAsImage: saveAsImage,
    saveAsPNG: function (canvas, width, height) {
      return saveAsImage(canvas, width, height, 'png')
    },
    saveAsJPEG: function (canvas, width, height) {
      return saveAsImage(canvas, width, height, 'jpeg')
    },
    saveAsGIF: function (canvas, width, height) {
      return saveAsImage(canvas, width, height, 'gif')
    },
    saveAsBMP: function (canvas, width, height) {
      return saveAsImage(canvas, width, height, 'bmp')
    },
    convertToImage,
    convertToPNG: function (canvas, width, height) {
      return convertToImage(canvas, width, height, 'png')
    },
    convertToJPEG: function (canvas, width, height) {
      return convertToImage(canvas, width, height, 'jpeg')
    },
    convertToGIF: function (canvas, width, height) {
      return convertToImage(canvas, width, height, 'gif')
    },
    convertToBMP: function (canvas, width, height) {
      return convertToImage(canvas, width, height, 'bmp')
    },
  }
})()
export function cvs2image(src) {
  const img = new Image()
  // 当图像加载完成时执行以下操作
  let oCanvas = document.createElement('canvas')
  img.onload = function () {
    // 创建一个 Canvas 元素，并获取其上下文
    const ctx = oCanvas.getContext('2d')
    // 设置 Canvas 尺寸与图像一致
    oCanvas.width = img.width
    oCanvas.height = img.height
    // 将图像绘制到 Canvas 上
    ctx.drawImage(img, 0, 0)
    // 在此之后，您可以对 Canvas 进行其他操作，如保存为图片或处理图像数据
  }
  // 设置 Image 元素的 src 属性为图像 URL，触发加载
  img.src = src // 替换为您的图像 URL
  return oCanvas
}

export const isSideMachineHole = (hole) => {
  return (
    hole.isSide == 1 ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.HINGE &&
      hole.symbol === 'HINGE')
  )
}
export const isSideMachineSlot = (slot) => {
  return (
    slot.isSide == 1 ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.STRENTCH &&
      ['STRENTCH', 'STRENTCHTWO', 'MIDSTRENTCH'].includes(slot.symbol)) ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.ALS &&
      slot.symbol === 'ALS')
  )
}
export const isOtherSideMachineHole = (hole) => {
  return (
    hole.isSide == '1' ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.HINGE &&
      hole.symbol === 'HINGE')
  )
}
export const isOtherSideMachineSlot = (slot) => {
  return (
    slot.isSide == '1' ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.STRENTCH &&
      ['STRENTCH', 'STRENTCHTWO', 'MIDSTRENTCH'].includes(slot.symbol)) ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.ALS &&
      slot.symbol === 'ALS')
  )
}

export const isSideMachineMillInfo = (mill) => {
  return (
    mill.isSide == '1' ||
    (store.state.ncSetting.sideHoleDrill &&
      store.state.ncSetting.side_machine_hole_slot.mill_info)
  )
}

export function getOtherSideMachineTargets(part, isFlipped = false) {
  const sideHoleList = (part.holes || []).filter((hole) =>
    isOtherSideMachineHole(hole)
  )
  const sideSlotList = (part.slots || []).filter((slot) =>
    isOtherSideMachineSlot(slot)
  )

  if (isFlipped) {
    return [
      ...sideHoleList.filter((hole) => hole.side == '-1'),
      ...sideSlotList.filter((slot) => slot.side == '-1'),
    ]
  }

  return [
    ...(part.sholes || []),
    ...(part.sslots || []),
    ...sideHoleList.filter((hole) => hole.side == '1'),
    ...sideSlotList.filter((slot) => slot.side == '1'),
  ]
}

/**
 *
 * @param {Number} num 处理的数字
 * @returns 不足三位补0
 */
export function dealNumber(num) {
  let numStr = ''
  const len = String(num).length
  if (len < 2) numStr = '00' + num
  else if (len < 3) numStr = '0' + num
  else numStr = String(num)
  return numStr
}
/**
 * @description 滚动至元素位置
 * @param {HTMLElement} dom
 * @returns *
 */
export function scrollToElementFn(dom) {
  dom.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}
export const delayTimer = async (delay = 0) => {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      resolve(true)
      clearTimeout(timer)
    }, delay)
  })
}
export const splitTime = () => {
  const date = new Date()
  const second = ('0' + date.getSeconds()).substr(-2, 2)
  const minute = ('0' + date.getMinutes()).substr(-2, 2)
  const hour = ('0' + date.getHours()).substr(-2, 2)
  const day = ('0' + date.getDate()).substr(-2, 2)
  const month = ('0' + (date.getMonth() + 1)).substr(-2, 2)
  const year = date.getFullYear()
  const dealTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
  return dealTime
}

/**
 * 四边修边xy互换情况处理
 * @param {*} trimEdge
 * @param {*} ncSetting
 * @param {*} isTag 是否是标签上的修边值展示
 * @returns 修边
 */
export function fourTrimEdge(trimEdge, ncSetting, isTag = false) {
  if (String(trimEdge)?.includes(',') && ncSetting.xyReverse) {
    const copyTrimEdge = JSON.parse(JSON.stringify(trimEdge)).split(',')
    let result = []
    if (
      ncSetting.startPosition == '右下角' ||
      ncSetting.startPosition == '左上角'
    ) {
      result = [
        copyTrimEdge[2],
        copyTrimEdge[3],
        copyTrimEdge[0],
        copyTrimEdge[1],
      ]
      // 标签排版图 互换后上下颠倒了
      if (isTag) {
        const copyResult = JSON.parse(JSON.stringify(result))
        result[0] = copyResult[1]
        result[1] = copyResult[0]
      }
      return result.join(',')
    } else {
      result = [
        copyTrimEdge[3],
        copyTrimEdge[2],
        copyTrimEdge[1],
        copyTrimEdge[0],
      ]
      // 标签排版图 互换后左右颠倒了
      if (isTag) {
        const copyResult = JSON.parse(JSON.stringify(result))
        result[2] = copyResult[3]
        result[3] = copyResult[2]
      }
      return result.join(',')
    }
  } else {
    return trimEdge
  }
}

export function handleJxEdge(trimEdge, isJx) {
  // 开启标签图镜像 四边修边左右对调
  if (trimEdge?.toString().includes(',') && isJx) {
    const copyTrimEdge = JSON.parse(JSON.stringify(trimEdge)).split(',')
    let result = [
      copyTrimEdge[0],
      copyTrimEdge[1],
      copyTrimEdge[3],
      copyTrimEdge[2],
    ]
    return result.join(',')
  } else {
    return trimEdge
  }
}

export function calcClosePlank(activePlank, bigPart) {
  const {
    parts,
    plankHeight,
    plankWidth,
    otherPlate,
    surplusInfo,
    path: bigPartPath,
  } = bigPart

  const symbol = `${activePlank.texture}:${activePlank.matCode}:${
    activePlank.thick
  }:${activePlank?.is_high_gloss_plank ? '高光' : '非高光'}`
  const diameter = activePlank.isUseSaw
    ? getSawKnife(store.state.ncSetting)
    : Number(getPlateKnifeDiameter(symbol, store.state.ncSetting)) //获取刀直径
  const rectPaths = getBoundingBoxFillRectPaths(bigPartPath)
  const edgeStripRects = getBoundingBoxEdgeStripRects(bigPart, {
    knifeR: diameter / 2,
    width: 200,
  })

  const otherParts = [...rectPaths, ...edgeStripRects].map((path) => {
    const xArr = path.map((p) => p.x)
    const yArr = path.map((p) => p.y)
    const startX = Math.min(...xArr)
    const startY = Math.min(...yArr)
    const width = Math.max(...xArr) - startX
    const height = Math.max(...yArr) - startY
    return {
      path: [dealPathToBasePoint(path)],
      startX,
      startY,
      width,
      height,
      partUniqueId: nanoid(),
      isBigEdge: true, // 是否大板边缘
      rect: {
        x: startX,
        y: startY,
        width,
        height,
      },
    }
  })
  // 获取存在碰撞的板件,减少运算
  const crashPlanks = getCrashPlankByActivePlank(
    activePlank,
    [...parts, ...otherParts],
    {
      activePlankOffset: ADSORPTION_RANGE,
    }
  )
  const re = calcClosePoint(activePlank, crashPlanks)
  if (!re) return
  const copyPlank = JSON.parse(JSON.stringify(activePlank))
  copyPlank.startX = re.x
  copyPlank.startY = re.y
  const res = calcClosePlankPoint(copyPlank, crashPlanks, {
    plankWidth,
    plankHeight,
    otherPlate,
    surplusInfo,
  })
  copyPlank.startX = res.x
  copyPlank.startY = res.y
  const finalRes = calcClosePlankPoint(copyPlank, crashPlanks, {
    plankWidth,
    plankHeight,
    otherPlate,
    surplusInfo,
  })
  return finalRes
}
function calcClosePlankPoint(activePlank, parts, options) {
  const ncSetting = store.state.ncSetting
  const gap = ncSetting.panelSize.layoutGap
  // 门套切割 排版间隙固定为0
  const isDoorFrame =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.processType === 'doorFrame' &&
    isSawPaiban(store)
  const sawGap = isDoorFrame ? 0 : ncSetting.sawSetting.sawBoardGap
  let layoutGap = activePlank.isUseSaw ? sawGap : gap

  const rectPoints = getRectPath(activePlank)
  const otherParts = parts.filter(
    (part) =>
      part.plankID !== activePlank.plankID || part.index !== activePlank.index
  )
  const otherPartsRectList = otherParts.map((part) => {
    return getRectPath(part)
  })

  let area = ClipperLib.JS.AreaOfPolygon(rectPoints)
  if (area > 0) {
    rectPoints.reverse()
  }

  const upperPoints = rectPoints.map((p) => ({ X: p.x, Y: p.y }))
  // 对板子进行扩板
  const gapRect = expandPath(layoutGap, upperPoints)
  // 扩板之后的startX,startY
  const gapStartPoint = {
    x: Math.min(...gapRect[0].map((p) => p.x)),
    y: Math.min(...gapRect[0].map((p) => p.y)),
  }

  const gapShape = new Polygon(gapRect[0].map((p) => point(p.x, p.y)))

  const otherShape = otherPartsRectList.map((rect) => {
    return new Polygon(rect.map((p) => point(p.x, p.y)))
  })

  const shortestRes = calcShortestDistance(gapShape, otherShape)
  const shortestDis = shortestRes.shortestDis
  let closeRes = shortestRes.closeRes
  // 吸附到的小板（与 otherShape 同序）
  const closePart = closeRes ? otherParts[closeRes.index] : null
  // 大板修边
  // const plankEdge =
  //   options?.otherPlate && Object.keys(options?.otherPlate).length
  //     ? options.otherPlate.trim_edge
  //     : store.state.historyPlankEdgeOff

  // 新增余料修边
  let plankEdge =
    options?.otherPlate && Object.keys(options?.otherPlate).length > 0
      ? options?.otherPlate.trim_edge
      : options?.surplusInfo &&
        Object.keys(options?.surplusInfo).length > 0 &&
        !options?.surplusInfo.isNotSurplus
      ? options?.surplusInfo.surplus_trim_edge
      : store.state.historyPlankEdgeOff
  let plankEdgeX
  let plankEdgeY
  // 有, 代表有四边修边
  if (plankEdge.toString().includes(',')) {
    const edgeArr = plankEdge.toString().split(',')
    plankEdgeX = Number(edgeArr[2])
    plankEdgeY = Number(edgeArr[0])
  } else {
    plankEdgeX = Number(plankEdge)
    plankEdgeY = Number(plankEdge)
  }
  // 刀径
  const diameter = Number(store.state.ncSetting.knife.diameter)

  // 板件没有重叠时
  if (shortestDis > 0) {
    const isSurplusPart =
      activePlank.surplusPath ||
      activePlank.specialType == 'supplus' ||
      (closePart &&
        (closePart.surplusPath || closePart.specialType == 'supplus'))
    /** 余料切割智能加速开关 */
    const isSurplusCutSmartSpeedUp =
      judgeSurplusCutSmartSpeedUp(ncSetting) && isSurplusPart

    // 判断位置，根据是否开启智能加速开关，判断是否需要偏移
    if (isSurplusCutSmartSpeedUp) {
      // 左
      if (closeRes.point1.x < closeRes.point2.x) {
        layoutGap += layoutGap
      }
      // 右
      if (closeRes.point1.x > closeRes.point2.x) {
        layoutGap -= layoutGap
      }
      // 上
      if (closeRes.point1.y < closeRes.point2.y) {
        layoutGap += layoutGap
      }
      // 下
      if (closeRes.point1.y > closeRes.point2.y) {
        layoutGap -= layoutGap
      }
    }
    let newStartX =
      gapStartPoint.x + closeRes.point2.x - closeRes.point1.x + layoutGap
    let newStartY =
      gapStartPoint.y + closeRes.point2.y - closeRes.point1.y + layoutGap
    if (shortestDis <= ADSORPTION_RANGE) {
      return {
        x:
          newStartX < 0
            ? plankEdgeX - diameter / 2
            : newStartX + activePlank.rect.width > options.plankWidth
            ? options.plankWidth - activePlank.rect.width
            : newStartX,
        y:
          newStartY < 0
            ? plankEdgeY - diameter / 2
            : newStartY + activePlank.rect.height > options.plankHeight
            ? options.plankHeight - activePlank.rect.height
            : newStartY,
        p1: closeRes.point1,
        p2: closeRes.point2,
        closePart,
      }
    } else {
      return {
        x: activePlank.startX,
        y: activePlank.startY,
        p1: closeRes.point1,
        p2: closeRes.point2,
        closePart,
      }
    }
  } else {
    const copyPlank = JSON.parse(JSON.stringify(activePlank))
    let closeResult = {
      x: copyPlank.startX,
      y: copyPlank.startY,
      p1: closeRes.point1,
      p2: closeRes.point2,
      closePart,
    }
    // 当前选中小板的真实轮廓的polygon
    const realRectPolygon = new Polygon(rectPoints.map((p) => point(p.x, p.y)))
    const realShortestRes = calcShortestDistance(realRectPolygon, otherShape)
    let samePoint = point(
      realShortestRes.closeRes.point2.x,
      realShortestRes.closeRes.point2.y
    )
    // 得到重叠/最近的板件（优先用真实轮廓算出的 index）
    const overlapPart = otherParts[realShortestRes.closeRes?.index] ?? closePart
    if (overlapPart?.isBigEdge) {
      layoutGap = 0
    }
    if (overlapPart) {
      const isSurplusPart =
        overlapPart.surplusPath ||
        overlapPart.specialType == 'supplus' ||
        activePlank.surplusPath ||
        activePlank.specialType == 'supplus'
      if (judgeSurplusCutSmartSpeedUp(ncSetting) && isSurplusPart) {
        layoutGap = 0
      }
    }
    // 转为polygon
    const overlapShape = new Polygon(
      getRectPath(overlapPart).map((p) => point(p.x, p.y))
    )
    // 判断真实小板是否与该板件重叠
    const intersect = BooleanOperations.intersect(
      realRectPolygon,
      overlapShape
    ).edges
    const isRealOverlap = Boolean(intersect.size)
    // 如果重叠，返回原始位置
    if (isRealOverlap) {
      // 多边形重叠的线条
      let shapeList = []
      intersect.forEach((shape) => {
        shapeList.push(shape.shape)
      })
      //过滤出X轴方向的线条
      const allPoints = shapeList.map((shape) => [shape.ps, shape.pe]).flat(1)
      const maxX = Math.max(...allPoints.map((point) => point.x))
      const minX = Math.min(...allPoints.map((point) => point.x))
      const maxY = Math.max(...allPoints.map((point) => point.y))
      const minY = Math.min(...allPoints.map((point) => point.y))
      // 判断板件的方位
      // if (minX > overlapPart.startX) {
      // 距左、距右
      let leftDis = Math.abs(maxX - overlapPart.startX)
      let rightDis = Math.abs(
        overlapPart.startX + overlapPart.rect.width - minX
      )
      // 距上、距下
      let topDis = Math.abs(maxY - overlapPart.startY)
      let bottomDis = Math.abs(
        overlapPart.startY + overlapPart.rect.height - minY
      )

      if (topDis < ADSORPTION_RANGE) {
        closeResult.y = minY - activePlank.rect.height - layoutGap
        // activePlank.startY = minY - activePlank.rect.height
      } else if (bottomDis < ADSORPTION_RANGE) {
        closeResult.y = maxY + layoutGap
      }
      if (leftDis < ADSORPTION_RANGE) {
        closeResult.x = minX - activePlank.rect.width - layoutGap
      } else if (rightDis < ADSORPTION_RANGE) {
        closeResult.x = maxX + layoutGap
      }

      // }
      // 过滤出
      return {
        ...closeResult,
        intersect: shapeList,
      }
    } else {
      const realClosePoint = realRectPolygon.distanceTo(overlapShape)
      samePoint = realClosePoint[1].pe
      // 否则判断小板的所处的方向进行点位偏移
      if (activePlank.startX > overlapPart.startX) {
        // 大于起始点的上下方向
        if (activePlank.startX < overlapPart.startX + overlapPart.rect.width) {
          closeResult = {
            x: copyPlank.startX,
            y:
              copyPlank.startY > overlapPart.startY
                ? samePoint.y + layoutGap
                : samePoint.y - copyPlank.rect.height - layoutGap,
            p1: realClosePoint[1].ps,
            p2: realClosePoint[1].pe,
          }
        } else {
          //小板右侧,向右弹开
          closeResult = {
            x: samePoint.x + layoutGap,
            y: copyPlank.startY,
            p1: realClosePoint[1].ps,
            p2: realClosePoint[1].pe,
          }
        }
      } else {
        if (copyPlank.startX < overlapPart.startX - copyPlank.rect.width) {
          closeResult = {
            x: samePoint.x - layoutGap - copyPlank.rect.width,
            y: copyPlank.startY,
            p1: realClosePoint[1].ps,
            p2: realClosePoint[1].pe,
          }
        } else {
          closeResult = {
            x: copyPlank.startX,
            y:
              copyPlank.startY > overlapPart.startY
                ? samePoint.y + layoutGap
                : samePoint.y - layoutGap - copyPlank.rect.height,
            p1: realClosePoint[1].ps,
            p2: realClosePoint[1].pe,
          }
        }
      }
    }
    return closeResult
  }
}

// 计算板件与其他板件的最短距离
function calcShortestDistance(currentShape, otherShape = []) {
  const formatRes = otherShape.map((shape, index) => {
    const r = currentShape.distanceTo(shape)
    return {
      index, // 对应 otherShape / otherParts 下标
      distance: r[0], // 两个板子之间的距离
      point1: r[1].ps, // activePlank上的点
      point2: r[1].pe, // 吸附板上的点
    }
  })

  const shortestDis = Math.min(...formatRes.map((res) => res.distance))
  return {
    shortestDis,
    closeRes: formatRes.find((res) => res.distance == shortestDis),
  }
}

// 获取小板逆时针的rect点位路径
function getRectPath(part) {
  return part.path
    ? part.path[0].map((p) => ({ x: p.x + part.startX, y: p.y + part.startY }))
    : [
        { x: part.startX, y: part.startY },
        {
          x: part.startX + part.rect.width,
          y: part.startY,
        },
        {
          x: part.startX + part.rect.width,
          y: part.startY + part.rect.height,
        },
        {
          x: part.startX,
          y: part.startY + part.rect.height,
        },
        { x: part.startX, y: part.startY },
      ]
}

/**
 * @description 将rect转换为path
 * @param {x, y, width, height} rect 轮廓
 * @returns
 */
export function rectToPath(rect) {
  const { x, y, width, height } = rect
  return [
    { x: x, y: y },
    { x: x + width, y: y },
    { x: x + width, y: y + height },
    { x: x, y: y + height },
  ]
}

/**
 * 生成order_address
 * @param {*} layoutData
 * @returns
 */
export function genOrderAddress(layoutData) {
  const orderAddressList = []
  layoutData.forEach((part) => {
    let order_adr = ''
    if (part.orderNo) {
      // 第三方跳转时可能address为空
      if (part.address) {
        order_adr = `${part.orderNo}-${part.address}`
      } else {
        order_adr = part.orderNo
      }
    } else {
      // 没有订单号的时候展示项目地址
      order_adr = part.address ?? ''
    }
    if (!orderAddressList.includes(order_adr) && order_adr) {
      orderAddressList.push(order_adr)
    }
  })
  return orderAddressList
}

/**
 * @description 根据尺寸修改L型余料的路径
 * @param {*} surplus 余料数据
 * @returns 处理后的余料数据
 */
export function dealLshapeSurplusFromSize(surplus) {
  const { width, long, min_width, min_long } = surplus
  const newSurplus = {
    ...surplus,
    width: width,
    long: long,
    min_width: min_width,
    min_long: min_long,
  }
  if (surplus.path) {
    const newPath = []
    // 更具缺口朝向处理 L 型余料的路径 坐标原点在左上角
    const copyPath = JSON.parse(JSON.stringify(surplus.path))

    const gapDir = getLShapeGapDir(dealPathToBasePoint(flipPath(copyPath)))
    switch (gapDir) {
      case 'topLeft':
        newPath.push(
          { x: 0, y: long - min_long },
          { x: 0, y: long },
          { x: width, y: long },
          { x: width, y: 0 },
          { x: width - min_width, y: 0 },
          { x: width - min_width, y: long - min_long },
          { x: 0, y: long - min_long }
        )
        break
      case 'topRight':
        newPath.push(
          { x: 0, y: 0 },
          { x: 0, y: long },
          { x: width, y: long },
          { x: width, y: long - min_long },
          { x: min_width, y: long - min_long },
          { x: min_width, y: 0 },
          { x: 0, y: 0 }
        )
        break
      case 'bottomLeft':
        newPath.push(
          { x: 0, y: 0 },
          { x: 0, y: min_long },
          { x: width - min_width, y: min_long },
          { x: width - min_width, y: long },
          { x: width, y: long },
          { x: width, y: 0 },
          { x: 0, y: 0 }
        )
        break
      case 'bottomRight':
        newPath.push(
          { x: 0, y: 0 },
          { x: 0, y: long },
          { x: min_width, y: long },
          { x: min_width, y: min_long },
          { x: width, y: min_long },
          { x: width, y: 0 },
          { x: 0, y: 0 }
        )
        break
    }
    newSurplus.path = newPath.map((p) => ({
      x: toDecimal(p.x, 2),
      y: toDecimal(p.y, 2),
    }))
  }
  return newSurplus
}

const _BBOX_FILL_EPS = 1e-6

/**
 * @description
 * 射线法判断点是否在多边形内部（用于轴对齐网格单元中心；边界点结果不稳定，网格与边对齐时可接受）。
 * 坐标系：原点左上角，x 向右、y 向下（画布坐标）；仅做数值比较，不依赖 y 轴向上/向下的区别。
 * @param {number} x
 * @param {number} y
 * @param {Array<{x:number,y:number}>} path 闭合路径，首尾可相同
 * @returns {boolean}
 */
function _pointInPolygonXY(x, y, path) {
  if (!path || path.length < 3) return false
  let inside = false
  const n = path.length
  const lastIsDup =
    n > 1 &&
    Math.abs(path[0].x - path[n - 1].x) < _BBOX_FILL_EPS &&
    Math.abs(path[0].y - path[n - 1].y) < _BBOX_FILL_EPS
  const m = lastIsDup ? n - 1 : n
  for (let i = 0, j = m - 1; i < m; j = i++) {
    const xi = path[i].x
    const yi = path[i].y
    const xj = path[j].x
    const yj = path[j].y
    if (Math.abs(yj - yi) < _BBOX_FILL_EPS) continue
    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }
  return inside
}

/**
 * @description 去重并排序
 * @param {number[]} arr
 * @param {number} eps
 * @returns {number[]}
 */
function _uniqueSortedNumbers(arr, eps) {
  const e = eps == null ? _BBOX_FILL_EPS : eps
  const sorted = [...arr].sort((a, b) => a - b)
  const out = []
  for (let k = 0; k < sorted.length; k++) {
    if (out.length === 0 || Math.abs(sorted[k] - out[out.length - 1]) > e) {
      out.push(sorted[k])
    }
  }
  return out
}

/**
 * @description 规范化闭合路径
 * @param {Array<{x:number,y:number}>} path
 * @returns {Array<{x:number,y:number}>}
 */
function _normalizeClosedPath(path) {
  if (!path || !path.length) return []
  const p = path.map((pt) => ({ x: Number(pt.x), y: Number(pt.y) }))
  const n = p.length
  if (n >= 2) {
    const a = p[0]
    const b = p[n - 1]
    if (
      Math.abs(a.x - b.x) < _BBOX_FILL_EPS &&
      Math.abs(a.y - b.y) < _BBOX_FILL_EPS
    ) {
      return p.slice(0, n - 1)
    }
  }
  return p
}

/**
 * @description 从边界生成矩形路径
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @returns {Array<{x:number,y:number}>}
 */
function _rectPathFromBounds(x1, y1, x2, y2) {
  const xa = Math.min(x1, x2)
  const xb = Math.max(x1, x2)
  const ya = Math.min(y1, y2)
  const yb = Math.max(y1, y2)
  return [
    { x: xa, y: ya },
    { x: xb, y: ya },
    { x: xb, y: yb },
    { x: xa, y: yb },
    { x: xa, y: ya },
  ]
}

/**
 * @description
 * 已知仅含水平/垂直边的正交多边形（红色）路径，求其与轴对齐外接矩形之间的「差集」区域，
 * 并分解为若干轴对齐绿色矩形路径（闭合，顺时针或逆时针均可复原为矩形）。
 * 适用于图示：L 形、阶梯缺口、单凹槽、双角缺口等，前提是红色区域为单连通、无孔洞。
 *
 * **坐标系约定**：原点位于左上角，x 向右为正、y 向下为正（与画布/浏览器一致）。
 * 输入与输出路径均使用该约定；外接矩形为水平竖直边，**minY 侧为视觉上的「上」边**。
 *
 * 思路：外接矩形与所有顶点坐标做坐标压缩得到网格；对每个网格中心做点在多边形内判断；
 * 不在红区内的格子为补集；按行生成条带再纵向合并成极大矩形，减少块数。
 *
 * @param {Array<{x:number,y:number}>} redPath 红色多边形顶点序列（闭合，末点可与首点重复）
 * @param {{ eps?: number, toDecimalDigits?: number }} [options]
 * @returns {Array<Array<{x:number,y:number}>>} 绿色矩形路径数组，每项为闭合矩形路径（5 点含首尾重合）
 */
export function getBoundingBoxFillRectPaths(redPath, options) {
  const opts = options || {}
  const eps = opts.eps != null ? opts.eps : _BBOX_FILL_EPS
  const digits = opts.toDecimalDigits != null ? opts.toDecimalDigits : null

  const path = _normalizeClosedPath(redPath)
  if (path.length < 3) return []

  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  for (let i = 0; i < path.length; i++) {
    const px = path[i].x
    const py = path[i].y
    if (px < minX) minX = px
    if (py < minY) minY = py
    if (px > maxX) maxX = px
    if (py > maxY) maxY = py
  }

  const xsRaw = [minX, maxX]
  const ysRaw = [minY, maxY]
  for (let i = 0; i < path.length; i++) {
    xsRaw.push(path[i].x)
    ysRaw.push(path[i].y)
  }
  const xs = _uniqueSortedNumbers(xsRaw, eps)
  const ys = _uniqueSortedNumbers(ysRaw, eps)
  if (xs.length < 2 || ys.length < 2) return []

  const colCount = xs.length - 1
  const rowCount = ys.length - 1

  /** @type {boolean[][]} */
  const empty = []
  for (let j = 0; j < rowCount; j++) {
    empty[j] = []
    const cy = (ys[j] + ys[j + 1]) / 2
    for (let i = 0; i < colCount; i++) {
      const cx = (xs[i] + xs[i + 1]) / 2
      const insideRed = _pointInPolygonXY(cx, cy, path)
      empty[j][i] = !insideRed
    }
  }

  /** @type {{ x1: number, x2: number, y1: number, y2: number }[]} */
  const rowStrips = []
  for (let j = 0; j < rowCount; j++) {
    let i = 0
    while (i < colCount) {
      if (!empty[j][i]) {
        i++
        continue
      }
      const i0 = i
      while (i < colCount && empty[j][i]) i++
      rowStrips.push({
        x1: xs[i0],
        x2: xs[i],
        y1: ys[j],
        y2: ys[j + 1],
      })
    }
  }

  rowStrips.sort((a, b) => a.y1 - b.y1 || a.x1 - b.x1)

  /** @type {{ x1: number, x2: number, y1: number, y2: number }[]} */
  const merged = []
  for (let s = 0; s < rowStrips.length; s++) {
    const strip = rowStrips[s]
    const prev = merged[merged.length - 1]
    if (
      prev &&
      Math.abs(prev.x1 - strip.x1) < eps &&
      Math.abs(prev.x2 - strip.x2) < eps &&
      Math.abs(prev.y2 - strip.y1) < eps
    ) {
      prev.y2 = strip.y2
    } else {
      merged.push({
        x1: strip.x1,
        x2: strip.x2,
        y1: strip.y1,
        y2: strip.y2,
      })
    }
  }

  const roundPt = (pt) => {
    if (digits == null) return pt
    return {
      x: toDecimal(pt.x, digits),
      y: toDecimal(pt.y, digits),
    }
  }

  return merged.map((r) =>
    _rectPathFromBounds(r.x1, r.y1, r.x2, r.y2).map(roundPt)
  )
}

/**
 * @description
 * 求路径的轴对齐外接矩形，并返回贴在外接矩形**四边**的条形矩形路径（用于「外扩边框」等）。
 * **坐标系**：原点左上角，x 向右、y 向下。
 *
 * 条形宽度 `width` 垂直于对应边（上边条高度、下边条高度、左右边条宽度均为该值）。
 * 为减少角部重复覆盖：上边条与下边条占满宽度；左右边条仅占据**上下边条之间的中间区域**（与上下条不重叠）。
 * 若外接矩形宽或高过小，条带会按比例缩短；无效（面积为零）的条不会放入结果。
 *
 * @param {IBigPlank} bigPart 大板
 * @param {{ width?: number, knifeR?: number}} [options] width 默认 10
 * @returns {Array<Array<{x:number,y:number}>>}
 * 依次为上边条、下边条、左侧条、右侧条（闭合路径）。
 * 中间竖区宽度不足两条并排侧条时会合并为一条通栏竖条，此时条数少于 4；某一侧无面积则不插入该项。
 */
export function getBoundingBoxEdgeStripRects(bigPart, options = {}) {
  const opts = options
  const { path, margin } = bigPart
  const T = Number(opts.width) > 0 ? Number(opts.width) : 10
  if (!path || !path.length || T <= 0) return []

  /** 所有点位 */
  const pts = path.map((pt) => ({ x: Number(pt.x), y: Number(pt.y) }))
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  for (let i = 0; i < pts.length; i++) {
    const px = pts[i].x
    const py = pts[i].y
    if (px < minX) minX = px
    if (py < minY) minY = py
    if (px > maxX) maxX = px
    if (py > maxY) maxY = py
  }

  /** @type {Array<Array<{x:number,y:number}>>} */
  const out = []
  /** 大板的修边值 左下右上*/
  const marginValueArr =
    isString(margin) && margin.includes(',')
      ? margin.split(',')
      : new Array(4).fill(Number(margin))
  /** 左侧偏移量 */
  const leftOffset = options.knifeR - marginValueArr[0]
  /** 底部偏移量 */
  const bottomOffset = options.knifeR - marginValueArr[1]
  /** 右侧偏移量 */
  const rightOffset = options.knifeR - marginValueArr[2]
  /** 顶部偏移量 */
  const topOffset = options.knifeR - marginValueArr[3]

  // 左侧矩形
  out.push([
    { x: minX - leftOffset - T, y: minY },
    { x: minX - leftOffset - T, y: maxY },
    { x: minX - leftOffset, y: maxY },
    { x: minX - leftOffset, y: minY },
  ])
  // 下侧矩形
  out.push([
    { x: minX, y: maxY + bottomOffset },
    { x: maxX, y: maxY + bottomOffset },
    { x: maxX, y: maxY + bottomOffset + T },
    { x: minX, y: maxY + bottomOffset + T },
  ])
  // 右侧矩形
  out.push([
    { x: maxX + rightOffset, y: minY },
    { x: maxX + rightOffset, y: maxY },
    { x: maxX + rightOffset + T, y: maxY },
    { x: maxX + rightOffset + T, y: minY },
  ])
  // 上侧矩形
  out.push([
    { x: minX, y: minY - topOffset - T },
    { x: maxX, y: minY - topOffset - T },
    { x: maxX, y: minY - topOffset },
    { x: minX, y: minY - topOffset },
  ])

  return out
}

export function judgeSurplusCutSmartSpeedUp(ncSetting) {
  return (
    store.state.preferencesSetting.setting.surplus_cut_smart_speed_up &&
    !ncSetting.sawSetting.mentaoji_enable &&
    !ncSetting.laser_enable &&
    !ncSetting.coedgeAccelerate &&
    !ncSetting.coedgeCutting &&
    !ncSetting.enable_integration_device &&
    ncSetting.cuttingEquipment == 'engraving'
  )
}
